/*
 * Quiz Overlay — logique du quiz morphologie.
 * Extrait de sections/quiz-overlay.liquid pour être mis en cache par le navigateur
 * au lieu d'être retéléchargé dans le HTML à chaque navigation.
 * Les données produit (catalogue Co 26) restent rendues par Liquid dans un
 * <script type="application/json"> à côté de l'overlay.
 */
(function () {
  function initQuizOverlay(ovl) {
    var sid = ovl.getAttribute('data-section-id');
    var closeBtn = document.getElementById('qovl-close-' + sid);

    // ---- Live product data (rendu par Liquid depuis la collection Co 26) ----
    var qCat = {};
    var dataEl = document.getElementById('qovl-catalog-' + sid);
    if (dataEl) {
      try { qCat = JSON.parse(dataEl.textContent) || {}; } catch (e) { qCat = {}; }
    }

    // ---- Caractéristiques par ligne de modèle (tous les coloris d'une ligne les partagent) ----
    // t = terrain[], w = largeur (discrete|equilibre|statement), v = face[], g = genre (homme|femme|mixte)
    var qLineMeta = {
      'BIARRITZ':     { t:['plage','city'],  w:'equilibre', v:['ovale','rond'],  g:'mixte' },
      'BROOKLYN':     { t:['city','skate'],  w:'equilibre', v:['ovale','carre'], g:'mixte' },
      'CANNES':       { t:['plage','club'],  w:'statement', v:['coeur','ovale'], g:'femme' },
      'CAPRI':        { t:['plage','city'],  w:'discrete',  v:['ovale','rond'],  g:'femme' },
      'DUBAI':        { t:['club','city'],   w:'statement', v:['ovale','carre'], g:'homme' },
      'IBIZA':        { t:['plage','club'],  w:'statement', v:['ovale','rond'],  g:'mixte' },
      'MALIBU':       { t:['plage','skate'], w:'equilibre', v:['ovale','carre'], g:'homme' },
      'MARBELLA':     { t:['plage','club'],  w:'statement', v:['coeur','ovale'], g:'femme' },
      'MILANO':       { t:['city','club'],   w:'discrete',  v:['ovale','carre'], g:'mixte' },
      'MONACO':       { t:['city','club'],   w:'discrete',  v:['ovale','carre'], g:'homme' },
      'MONTAUK':      { t:['skate','plage'], w:'statement', v:['carre','ovale'], g:'homme' },
      'MYKONOS':      { t:['plage','city'],  w:'equilibre', v:['ovale','rond'],  g:'femme' },
      'PORTOFINO':    { t:['city','plage'],  w:'discrete',  v:['ovale','coeur'], g:'mixte' },
      'RIVIERA':      { t:['plage','club'],  w:'statement', v:['ovale','carre'], g:'femme' },
      'SAINT TROPEZ': { t:['plage','club'],  w:'equilibre', v:['coeur','rond'],  g:'femme' },
      'SANTORINI':    { t:['plage','city'],  w:'equilibre', v:['ovale','rond'],  g:'mixte' },
      'SEOUL':        { t:['city','skate'],  w:'discrete',  v:['ovale','carre'], g:'mixte' },
      'VENICE':       { t:['plage','club'],  w:'statement', v:['ovale','carre'], g:'femme' }
    };

    // Titre Shopify au format "MODELE - COLORIS" (ex. "SANTORINI - BLEU VERT")
    function normalizeText(s) {
      s = (s || '').toUpperCase();
      return s.normalize ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s;
    }

    function splitTitle(title) {
      var parts = (title || '').split(' - ');
      return {
        line: normalizeText(parts[0]).trim(),
        color: normalizeText(parts.slice(1).join(' - ')).trim()
      };
    }

    // Teinte déduite du coloris réel du produit (aucune supposition : c'est le texte du titre Shopify).
    // On lit les mots du coloris DANS L'ORDRE : le premier mot reconnu gagne, car c'est la teinte
    // dominante ("NOIR ORANGE" = noir, "ROSE VERT" = rose, "VERT OR" = bleu/vert).
    // ORANGE / JAUNE sont des teintes chaudes : elles appartiennent au groupe ambre/marron,
    // surtout pas au groupe rose (sinon « rose » renvoie des montures orange).
    var COLOR_WORDS = {
      bleu:   ['BLEU', 'VERT', 'TURQUOISE', 'CIEL'],
      marron: ['MARRON', 'AMBRE', 'AMBER', 'ORANGE', 'JAUNE', 'SABLE', 'TEA', 'CREME', 'IVOIRE', 'LEOPARD', 'ECAILLE', 'MIEL', 'CARAMEL', 'BEIGE', 'MOUTARDE'],
      rose:   ['ROSE', 'ROSA', 'MAUVE', 'VIOLET', 'LILAS', 'PARME', 'FUCHSIA', 'ROUGE', 'BORDEAUX', 'PECHE', 'CORAIL', 'DEGRADE'],
      noir:   ['NOIR', 'GRIS', 'FUME', 'SMOKED', 'CLEAR', 'TRANSPARENT', 'CRISTAL', 'ARGENT', 'BLANC', 'OR', 'GOLD']
    };

    function colorBucket(colorRaw) {
      var words = normalizeText(colorRaw).split(/[^A-Z0-9]+/);
      for (var i = 0; i < words.length; i++) {
        for (var bucket in COLOR_WORDS) {
          if (COLOR_WORDS[bucket].indexOf(words[i]) !== -1) return bucket;
        }
      }
      return 'noir';
    }

    function getMeta(handle) {
      var p = qCat[handle];
      if (!p) return null;
      var parts = splitTitle(p.name);
      var line = qLineMeta[parts.line];
      if (!line) return null;
      return { t: line.t, w: line.w, v: line.v, g: line.g, c: colorBucket(parts.color) };
    }

    // ---- Scoring ----
    // La teinte est un critère ÉLIMINATOIRE : une paire proposée doit toujours porter
    // l'une des teintes cochées à l'étape 5.
    function teinteMatch(bucket, answers) {
      return !answers.teinte.length || answers.teinte.indexOf(bucket) !== -1;
    }

    function lineOf(handle) {
      return splitTitle((qCat[handle] || {}).name).line;
    }

    function score(handle, answers) {
      var m = getMeta(handle);
      if (!m) return -1;
      var s = 0;
      // Genre (poids 3) — mixte convient toujours un peu
      if (answers.genre) {
        if (m.g === answers.genre) s += 3;
        else if (m.g === 'mixte') s += 2;
      }
      // Terrain (poids 4)
      if (m.t.indexOf(answers.terrain) !== -1) s += 4;
      // Teinte (poids 3) — filtrée en dur dans getDuo(), le bonus ne sert qu'au classement de secours
      if (teinteMatch(m.c, answers)) s += 3;
      // Face (poids 2)
      if (m.v.indexOf(answers.face) !== -1) s += 2;
      // Largeur (poids 2) — surprise = bonus neutre
      if (answers.largeur === 'surprise') s += 1;
      else if (m.w === answers.largeur) s += 2;
      return s;
    }

    // Renvoie 2 handles. Règles, dans l'ordre :
    //  1. les deux paires portent obligatoirement une teinte cochée à l'étape 5 ;
    //  2. la 2e paire est d'une autre ligne de modèle (duo visuellement distinct) ;
    //  3. si plusieurs teintes ont été cochées, on essaie d'en proposer une de chaque.
    function getDuo(answers) {
      var all = Object.keys(qCat).filter(function(h) { return getMeta(h); });
      if (!all.length) return [];

      // 1. Filtre dur sur la teinte (fallback catalogue complet si aucun coloris ne correspond)
      var pool = all.filter(function(h) { return teinteMatch(getMeta(h).c, answers); });
      if (!pool.length) pool = all;

      pool.sort(function(a, b) { return score(b, answers) - score(a, answers); });

      var first = pool[0];
      var firstLine = lineOf(first);
      var firstColor = getMeta(first).c;
      var rest = pool.slice(1);

      // 2. Autre ligne de modèle
      var otherLine = rest.filter(function(h) { return lineOf(h) !== firstLine; });

      // 3. Teinte différente si l'utilisateur en a coché plusieurs
      var second = null;
      if (answers.teinte.length > 1) {
        second = otherLine.filter(function(h) { return getMeta(h).c !== firstColor; })[0];
      }
      if (!second) second = otherLine[0];
      if (!second) second = rest[0];
      if (!second) second = first;

      return [first, second];
    }

    // ---- Money formatting (respecte le format de la boutique) ----
    function formatMoney(cents) {
      var format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '\x7b\x7bamount\x7d\x7d';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var match = format.match(placeholderRegex);
      if (!match) return String(cents);
      function withDelimiters(number, precision, thousands, decimal) {
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        var rest = parts[1] ? decimal + parts[1] : '';
        return dollars + rest;
      }
      var value;
      switch (match[1]) {
        case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        default: value = withDelimiters(cents, 2, ',', '.');
      }
      return format.replace(placeholderRegex, value);
    }

    // ---- State ----
    var answers = { genre: null, face: null, terrain: null, largeur: null, teinte: [] };
    var currentDuo = [];

    // ---- Open / close ----
    function openOverlay() {
      ovl.classList.add('qovl--open');
      ovl.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      history.pushState(null, '', '#quiz');
    }

    function closeOverlay() {
      ovl.classList.remove('qovl--open');
      ovl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (location.hash === '#quiz') history.pushState(null, '', location.pathname);
    }

    if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
    ovl.addEventListener('click', function(e) { if (e.target === ovl) closeOverlay(); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && ovl.classList.contains('qovl--open')) closeOverlay();
    });

    // ---- Intercept quiz links ----
    function interceptLinks() {
      document.querySelectorAll('a[href*="quiz-style"], a[href="#quiz"], [data-quiz-trigger]').forEach(function(el) {
        if (el._qovlBound) return;
        el._qovlBound = true;
        el.addEventListener('click', function(e) { e.preventDefault(); openOverlay(); });
      });
    }
    interceptLinks();
    new MutationObserver(interceptLinks).observe(document.body, { childList: true, subtree: true });

    function checkHash() { if (location.hash === '#quiz') openOverlay(); }
    window.addEventListener('hashchange', checkHash);
    checkHash();

    // ---- Step navigation ----
    function goTo(step) {
      ovl.querySelectorAll('.sqz__step').forEach(function(el) { el.classList.remove('visible'); });
      ovl.querySelectorAll('[data-qdot]').forEach(function(d) {
        d.classList.toggle('active', parseInt(d.dataset.qdot) <= step);
      });
      var target = ovl.querySelector('[data-qstep="' + step + '"]');
      if (target) target.classList.add('visible');
      ovl.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // ---- Radio options ----
    ovl.querySelectorAll('.sqz__option:not([data-qmulti])').forEach(function(opt) {
      opt.addEventListener('click', function() {
        var inp = opt.querySelector('input[type="radio"]');
        if (!inp) return;
        ovl.querySelectorAll('[name="' + inp.name + '"]').forEach(function(r) {
          r.closest('.sqz__option').classList.remove('selected');
        });
        opt.classList.add('selected');
        inp.checked = true;
        answers[inp.name.replace('q', '')] = inp.value;
        var step = opt.closest('.sqz__step');
        if (step) { var nb = step.querySelector('[data-qnext]'); if (nb) nb.disabled = false; }
      });
    });

    // ---- Checkbox options (teinte multi-select) ----
    ovl.querySelectorAll('.sqz__option[data-qmulti]').forEach(function(opt) {
      opt.addEventListener('click', function() {
        var inp = opt.querySelector('input[type="checkbox"]');
        if (!inp) return;
        inp.checked = !inp.checked;
        opt.classList.toggle('selected', inp.checked);
        answers.teinte = [];
        ovl.querySelectorAll('[name="qteinte"]:checked').forEach(function(cb) { answers.teinte.push(cb.value); });
        var sb = document.getElementById('qshow-results-' + sid);
        if (sb) sb.disabled = answers.teinte.length === 0;
      });
    });

    // ---- Next / Back ----
    ovl.addEventListener('click', function(e) {
      var nb = e.target.closest('[data-qnext]');
      if (nb && !nb.disabled) { goTo(parseInt(nb.dataset.qnext)); return; }
      var bb = e.target.closest('[data-qback]');
      if (bb) { goTo(parseInt(bb.dataset.qback)); return; }
    });

    // ---- Show results ----
    var showBtn = document.getElementById('qshow-results-' + sid);
    if (showBtn) {
      showBtn.addEventListener('click', function() {
        if (showBtn.disabled) return;
        showResults();
      });
    }
    var QS = (window.growStrings && window.growStrings.quiz) || {};


    var GENRE_LABEL = QS.genre || { homme: 'homme', femme: 'femme' };
    var FACE_LABEL = QS.face || { ovale: 'ovale', carre: 'carré', rond: 'rond', coeur: 'cœur' };
    var TERRAIN_LABEL = QS.terrain || { skate: 'rue & skate', club: 'soirée', plage: 'plage', city: 'ville' };
    var LARGEUR_LABEL = QS.largeur || { discrete: 'discrète', equilibre: 'équilibré', statement: 'statement', surprise: 'surprise' };
    var TEINTE_LABEL = QS.teinte || { noir: 'fumé', marron: 'ambré', bleu: 'bleu/vert', rose: 'rose' };
    var TEINTE_DOT = { noir: '#3A3A3A', marron: '#8A4B1B', bleu: '#2E6E9E', rose: '#C86A8E' };

    // Coloris disponibles pour la même ligne de modèle qu'un handle donné, restreints aux
    // teintes cochées (le coloris affiché reste toujours proposé, quoi qu'il arrive).
    function lineHandles(handle) {
      var line = lineOf(handle);
      var bucketOrder = ['noir', 'marron', 'bleu', 'rose'];
      var list = Object.keys(qCat).filter(function(h) {
        return getMeta(h) && lineOf(h) === line &&
          (h === handle || teinteMatch(getMeta(h).c, answers));
      });
      if (list.indexOf(handle) === -1) list.push(handle);
      return list.sort(function(a, b) {
        return bucketOrder.indexOf(getMeta(a).c) - bucketOrder.indexOf(getMeta(b).c);
      });
    }

    // Duo cards (+ leurs coloris alternatifs cliquables)
    var ranks = QS.ranks || ['Paire 1', 'Paire 2'];
    function renderDuoCards() {
      var duoEl = document.getElementById('qduo-' + sid);
      if (!duoEl) return;
      duoEl.innerHTML = currentDuo.map(function(h, i) {
        var p = qCat[h];
        if (!p) return '';
        var m = getMeta(h) || {};
        var desc = 'Verre ' + (TEINTE_LABEL[m.c] || m.c) + ', format ' + (LARGEUR_LABEL[m.w] || m.w);
        var sw = lineHandles(h).map(function(altH) {
          var altC = getMeta(altH).c;
          return '<i class="' + (altH === h ? 'on' : '') + '" data-idx="' + i + '" data-handle="' + altH +
            '" style="background:' + TEINTE_DOT[altC] + '" title="' + qCat[altH].name + '"></i>';
        }).join('');
        return '<div class="sqz__pcard">' +
          '<div class="sqz__pcard-img"><span class="sqz__pcard-rank">' + ranks[i] + '</span>' +
            '<img src="' + p.img + '" alt="' + p.name + '" loading="lazy"></div>' +
          '<div class="sqz__pcard-b">' +
            '<p class="sqz__pcard-n">' + p.name + '</p>' +
            '<p class="sqz__pcard-w">' + desc + '</p>' +
            '<div class="sqz__pcard-sw">' + sw + '</div>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    // Prix du duo = pack 2 paires (remise auto Shopify, voir pack2Off dans layout/theme.liquid)
    function renderPricing() {
      var p1 = qCat[currentDuo[0]];
      var p2 = qCat[currentDuo[1]];
      var addLabel = document.getElementById('qaddcart-label-' + sid);
      var addBtnEl = document.getElementById('qaddcart-' + sid);
      if (p1 && p2) {
        var original = p1.priceCents + p2.priceCents;
        var final = Math.max(0, original - (typeof QS.pack2Off === "number" ? QS.pack2Off : 995));
        var perUnit = Math.round(final / 2);
        var origEl = document.getElementById('qprice-orig-' + sid);
        var finalEl = document.getElementById('qprice-final-' + sid);
        var perEl = document.getElementById('qprice-per-' + sid);
        if (origEl) origEl.textContent = formatMoney(original);
        if (finalEl) finalEl.textContent = formatMoney(final);
        if (perEl) perEl.textContent = (QS.perPair || 'soit __PRICE__ la paire').replace('__PRICE__', formatMoney(perUnit));
        if (addLabel) addLabel.textContent = (QS.addPack || 'Ajouter mes 2 paires · __PRICE__').replace('__PRICE__', formatMoney(final));
        if (addBtnEl) addBtnEl.disabled = false;
      } else if (addBtnEl) {
        addBtnEl.disabled = true;
      }
    }

    // Changer le coloris d'une des deux paires du duo
    var duoElForClicks = document.getElementById('qduo-' + sid);
    if (duoElForClicks) {
      duoElForClicks.addEventListener('click', function(e) {
        var dot = e.target.closest('.sqz__pcard-sw i[data-handle]');
        if (!dot) return;
        var idx = parseInt(dot.dataset.idx, 10);
        currentDuo[idx] = dot.dataset.handle;
        renderDuoCards();
        renderPricing();
      });
    }

    function showResults() {
      currentDuo = getDuo(answers);

      // Why line
      var whyEl = document.getElementById('qresults-why-' + sid);
      if (whyEl) {
        var teinteTxt = answers.teinte.length
          ? answers.teinte.map(function(t) { return TEINTE_LABEL[t] || t; }).join(' + ')
          : (QS.allTints || 'toutes');
        var genrePrefix = answers.genre
          ? (QS.whyFor || 'Pour <b>__GENRE__</b> · ').replace('__GENRE__', GENRE_LABEL[answers.genre] || answers.genre)
          : '';
        whyEl.innerHTML = genrePrefix + (QS.whySummary || 'Visage <b>__FACE__</b> · usage <b>__TERRAIN__</b> · format <b>__LARGEUR__</b> · teintes <b>__TEINTES__</b>.')
          .replace('__FACE__', FACE_LABEL[answers.face] || '—')
          .replace('__TERRAIN__', TERRAIN_LABEL[answers.terrain] || '—')
          .replace('__LARGEUR__', LARGEUR_LABEL[answers.largeur] || '—')
          .replace('__TEINTES__', teinteTxt);
      }

      renderDuoCards();
      renderPricing();

      // Remaining models count
      var linksCountEl = document.getElementById('qlinks-count-' + sid);
      if (linksCountEl) {
        var remaining = Math.max(Object.keys(qCat).length - 2, 0);
        linksCountEl.textContent = remaining + (remaining > 1 ? ' autres' : ' autre');
      }

      // Show results panel
      ovl.querySelectorAll('.sqz__step').forEach(function(el) { el.classList.remove('visible'); });
      ovl.querySelectorAll('[data-qdot]').forEach(function(d) { d.classList.add('active'); });
      var resultsEl = document.getElementById('qresults-' + sid);
      if (resultsEl) resultsEl.classList.add('visible');
      ovl.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // ---- Add duo to cart ----
    var addBtn = document.getElementById('qaddcart-' + sid);
    if (addBtn) {
      addBtn.addEventListener('click', function() {
        if (addBtn.disabled || !currentDuo.length) return;
        var p1 = qCat[currentDuo[0]];
        var p2 = qCat[currentDuo[1]];
        if (!p1 || !p2) return;

        addBtn.disabled = true;
        var labelEl = document.getElementById('qaddcart-label-' + sid);
        var originalLabel = labelEl ? labelEl.textContent : '';
        if (labelEl) labelEl.textContent = QS.adding || 'Ajout en cours…';

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              { id: p1.vid, quantity: 1 },
              { id: p2.vid, quantity: 1 }
            ]
          })
        })
          .then(function(r) { if (!r.ok) throw new Error('cart add failed'); return r.json(); })
          .then(function() {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            closeOverlay();
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') {
              setTimeout(function() { drawer.show(); }, 150);
            }
          })
          .catch(function() {
            window.location.href = root + 'cart';
          })
          .finally(function() {
            addBtn.disabled = false;
            if (labelEl) labelEl.textContent = originalLabel;
          });
      });
    }

    // ---- Restart ----
    var restartBtn = document.getElementById('qrestart-' + sid);
    if (restartBtn) {
      restartBtn.addEventListener('click', function() {
        answers = { genre: null, face: null, terrain: null, largeur: null, teinte: [] };
        currentDuo = [];
        ovl.querySelectorAll('.sqz__option').forEach(function(o) { o.classList.remove('selected'); });
        ovl.querySelectorAll('input').forEach(function(i) { i.checked = false; });
        ovl.querySelectorAll('[data-qnext]').forEach(function(b) { b.disabled = true; });
        var sb = document.getElementById('qshow-results-' + sid);
        if (sb) sb.disabled = true;
        var re = document.getElementById('qresults-' + sid);
        if (re) re.classList.remove('visible');
        goTo(1);
      });
    }
  }

  function boot() {
    document.querySelectorAll('.qovl[data-section-id]').forEach(function (ovl) {
      if (ovl.dataset.qovlReady) return;
      ovl.dataset.qovlReady = '1';
      initQuizOverlay(ovl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
